import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './reviews-table.css';

export default function GeneralAssessmentModal({
                                                   show,
                                                   onClose,
                                                   section,
                                                   roleLabel = 'Employee',
                                                   value = '',
                                                   canEdit = false,
                                                   onSave,
                                               }) {
    const [comment, setComment] = useState(value || '');
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        setComment(value || '');
    }, [value]);

    useEffect(() => {
        if (!show) return;
        document.body.classList.add('modal-open');
        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [show]);

    if (!show) return null;

    const handleSave = async () => {
        if (!canEdit) return;
        setBusy(true);
        try {
            await onSave?.(comment);
            onClose?.();
        } finally {
            setBusy(false);
        }
    };

    return ReactDOM.createPortal(
        <>
            <div className="modal-backdrop fade show" onClick={onClose} aria-hidden="true" style={{ cursor: 'pointer' }} />

            <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">General Assessment</h5>
                            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                        </div>

                        <div className="modal-body">
                            <div className="mb-3">
                                <div className="fw-semibold">Prompt</div>
                                <div className="text-muted">{section?.prompt || '—'}</div>
                            </div>

                            <div className="mb-2 fw-semibold">{roleLabel} Comment</div>
                            <textarea
                                className="form-control form-control-sm"
                                rows={6}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                disabled={!canEdit}
                                placeholder="Capture your summary here…"
                            />
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-light btn-sm" onClick={onClose} disabled={busy}>Close</button>
                            <button className="btn btn-primary btn-sm" onClick={handleSave} disabled={!canEdit || busy}>
                                {busy ? 'Saving…' : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
}
